import { InputHTMLAttributes } from 'react';

import { InputField } from '~/shared/ui/InputField/InputField';

import { useLocalization } from '../../localization/localization';

import { Currency, Divider, StyledCountryLogo } from './AmountInput.ui';

export interface AmountInputProps
  extends InputHTMLAttributes<HTMLInputElement> {
  maxAmount: string;
  minAmount: string;

  error?: React.ReactNode;
  inputClassName?: string;
}

export const AmountInput = (props: AmountInputProps) => {
  const { error, maxAmount, minAmount, ...inputProps } = props;
  const { t } = useLocalization();

  return (
    <InputField
      error={error}
      description={t('Amount description', { maxAmount, minAmount })}
      inputProps={{
        ...inputProps,
        placeholder: t('Amount placeholder'),
        prefixIcon: (
          <>
            <StyledCountryLogo />
            <Currency>USD</Currency>
            <Divider />
          </>
        ),
        type: 'text',
        inputMode: 'decimal',
      }}
      label={t('Amount label')}
    />
  );
};
